import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import Loading from "./components/Loading";
import Toast from "./components/Toast";
import { queryClient } from "./config/query";
import router from "./routes/router";
import { useAuth } from './hooks/useAuth';
import { useEffect } from "react";

function App() {
  const { isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Loading />
      <RouterProvider router={router} />
      <Toast />
    </QueryClientProvider>
  );
}

export default App;
